import update from 'immutability-helper';
import { SocketReduxActions } from './Action';

interface SocketData {
    eventName: string | null;
    env?: string;
}
export interface SocketState {
    active: boolean;
    counter: number;
    socketData: SocketData;
    socketLink: string;
}

export const socketState: SocketState = {
    active: false,
    counter: 0,
    socketData: {
        eventName: null,
    },
    socketLink: '',
};

const ProfileStateReducer = (
    state = socketState,
    action: any = { type: '', payload: {} }
): SocketState => {
    switch (action.type) {
        case SocketReduxActions.SOCKET_CLOSE_HANDSHAKE:
            return update(state, {
                $merge: {
                    ...socketState,
                },
            });

        case SocketReduxActions.ACTION_REDUX_WORKER:
            return update(state, {
                $merge: {
                    ...action.payload,
                },
            });
        case SocketReduxActions.TO_SOCKET_REDUX_WORKER:
            return update(state, {
                $merge: {
                    counter: state.counter + 1,
                    socketData: {
                        ...action.payload,
                    },
                },
            });
        case SocketReduxActions.TO_REMOVE_SOCKET_EVENT:
            return update(state, {
                $merge: {
                    counter: 0,
                    socketData: {
                        eventName: socketState.socketData.eventName,
                    },
                },
            });
        case SocketReduxActions.SOCKET_INITIAL_HANDSHAKE:
            return update(state, {
                $merge: {
                    socketLink: action.payload,
                },
            });
        case SocketReduxActions.TO_SOCKET_INITIAL_HANDSHAKE:
            return update(state, {
                $merge: {
                    active: action.payload,
                },
            });
        default:
            return state;
    }
};

export default ProfileStateReducer;
